let appMode = "production";
if (
  window.location.origin === "http://localhost:4000" ||
  window.location.origin === "http://192.168.1.1:4000/"
) {
  appMode = "stage";
}
let newlive = "https://backend.buyandbee.com/";
let stage = "https://backend.buyandbee.com/";
let adminPath = "";
let adminDir = "";
let image = "";



if (appMode === "production") {
  newlive = "https://backend.buyandbee.com/";
  newlive = "https://backend.buyandbee.com/";
  image = "https://backend.buyandbee.com";
  adminPath = "http://35.168.230.175:4000";
  adminDir = "https://buyandbee.com";
} else {
  stage = "https://backend.buyandbee.com/";
  image = "https://backend.buyandbee.com";
  adminPath = "http://35.168.230.175:4000";
  adminDir = "https://buyandbee.com";
}


let URL = appMode === "production" ? newlive : stage;

console.log(URL);
let pathObj = {
  baseURL: URL,
  // baseUrlDriver:baseUrlDriver,
  //Image URL
  imageURL: image,
  adminPath: adminPath,
  adminDir: adminDir,

  //Basic Url
  adminLogin: "api/admins/login",
  forgotPassword: "api/admins/forgot-password",
  unlockAccountSendOTP: "api/admins/unlock-account-send-otp",
  unlockAccountVerifyOTP: "api/admins/unlock-account-verify-otp",
  changePassword: "api/admins/change-password",
  dashboardData: "api/admins/dashboardData",
  graphData: "api/admins/graphData",
  updateAdminProfile: "api/admins/updateAdminProfile",
  vendorData: "api/admins/vendorData",
  deliveryboysData: "api/admins/deliveryboysData",
  getStateCityArea: "api/admins/state-city-area",
  docUploadImage: "api/admins/doc-upload-image",
  getAdminNotifications: "api/admins/getAdminNotifications",
  deleteNotification: "api/admins/deleteNotification",
  updateBusniessUserStatus: "api/admins/updateBusniessUserStatus",

  //Main Services URL
  getMainServices: "api/admins/getMainServices",
  addMainService: "api/admins/addMainService",
  updateMainService: "api/admins/updateMainService",
  updateMainServiceStatus: "api/admins/updateMainServiceStatus",
  getAllMainService: "api/admins/getAllMainService",

  //Services URL
  getServices: "api/admins/getServices",
  addService: "api/admins/addService",
  updateService: "api/admins/updateService",
  updateServiceStatus: "api/admins/updateServiceStatus",
  getAllService: "api/admins/getAllService",

  //Car Category URL
  getCarCategories: "api/admins/getCarCategories",
  getAllCarCategory: "api/admins/getAllCarCategory",
  getAllCarCategoryMultiple: "api/admins/getAllCarCategoryMultiple",
  addCarCategory: "api/admins/addCarCategory",
  updateCarCategory: "api/admins/updateCarCategory",
  updateCarCategoryStatus: "api/admins/updateCarCategoryStatus",

  //Car Brand URL
  getCarBrands: "api/admins/getCarBrands",
  getAllBrandMultiple: "api/admins/getAllCarBrandMultiple",
  addCarBrand: "api/admins/addCarBrand",
  updateCarBrand: "api/admins/updateCarBrand",
  updateCarBrandStatus: "api/admins/updateCarBrandStatus",

  //Car Model URL
  getCarModels: "api/admins/getCarModels",
  getAllModelMultiple: "api/admins/getAllCarModelMultiple",
  addCarModel: "api/admins/addCarModel",
  updateCarModel: "api/admins/updateCarModel",
  updateCarModelStatus: "api/admins/updateCarModelStatus",


  //Car Variant URL
  getVariant: "api/admins/getVariant",
  getAllVariantMultiple: "api/admins/getAllVariantMultiple",
  addVariant: "api/admins/addVariant",
  updateVariant: "api/admins/updateVariant",
  updateVariantStatus: "api/admins/updateVariantStatus",
  //Car Fuel URL
  getFuel: "api/admins/getFuel",
  getAllFuelMultiple: "api/admins/getAllFuelMultiple",
  getAllFuel: "api/admins/getAllFuel",
  addFuel: "api/admins/addFuel",
  updateFuel: "api/admins/updateFuel",
  updateFuelStatus: "api/admins/updateFuelStatus",

  //Cars Sell URL
  getSellCars: "api/admins/getSellCars",
  updateCarSellStatus: "api/admins/updateCarSellStatus",
  addCarseller: "api/admins/addCarseller",
  editCarSeller: "api/admins/editCarSeller",

  //Products Sell URL
  getSellProducts: "api/admins/getSellProducts",
  updateProductSellStatus: "api/admins/updateProductSellStatus",
  getProductsAccordingSeller: "api/admins/getProductsAccordingSeller",
  addProductSeller: "api/admins/addProductSeller",
  editProductSeller: "api/admins/editProductSeller",

  //Cars URL
  getCars: "api/admins/getCars",
  addCar: "api/admins/addCar",
  getAllCar: "api/admins/getAllCar",
  updateCar: "api/admins/updateCar",
  updateCarStatus: "api/admins/updateCarStatus",
  getAllCarCSV: "api/admins/getAllCarCSV",

  //Category URL
  getCategories: "api/admins/getCategories",
  addCategory: "api/admins/addCategory",
  updateCategory: "api/admins/updateCategory",
  getAllCategory: "api/admins/getAllCategory",
  getAllProducts: "api/admins/getAllProducts",
  getAllEmirate: "api/admins/getAllEmirate",
  getEmirates: "api/admins/getEmirates",
  getAllCategoryMultiple: "api/admins/getAllCategoryMultiple",
  getInventCategory: "api/admins/getInventCategory",
  updateCategoryStatus: "api/admins/updateCategoryStatus",

  //Occasions URL
  getOccasions: "api/admins/getOccasions",
  addOccasion: "api/admins/addOccasion",
  updateOccasion: "api/admins/updateOccasion",
  getAllOccasion: "api/admins/getAllOccasion",
  getAllOccasionMultiple: "api/admins/getAllOccasionMultiple",
  updateOccasionStatus: "api/admins/updateOccasionStatus",
  //Sub Category URL
  getSubCategories: "api/admins/getSubCategories",
  addSubCategories: "api/admins/addSubCategories",
  updateSubCategories: "api/admins/updateSubCategories",
  getAllSubCategories: "api/admins/getAllSubCategories",
  getAllSubCategoriesTree: "api/admins/getAllSubCategoriesTree",
  getAllChildSubCategories: "api/admins/getAllChildSubCategories",
  getInventSubCategories: "api/admins/getInventSubCategories",
  getAllSubCategoriesMultiple: "api/admins/getAllSubCategoriesMultiple",
  updateSubCategoriesStatus: "api/admins/updateSubCategoriesStatus",
  getProductList: "api/admins/getProductList",

  //Banners URL
  getBanners: "api/admins/getBanners",
  addBanner: "api/admins/addBanners",
  updateBanner: "api/admins/updateBanner",

  //Advertisements URL
  getAdvertisements: "api/admins/getAdvertisement",
  addAdvertisement: "api/admins/addAdvertisement",
  updateAdvertisement: "api/admins/updateAdvertisement",
  getAdvertiseDisplayPage: "api/admins/getAdvertiseDisplayPage",

  //Settings URL
  getSettings: "api/admins/getSettings",
  updateSettings: "api/admins/updateSettings",

  //DeliveryPrice URL
  getDeliveryPrice: "api/admins/getDeliveryPrice",
  updateDeliveryPrice: "api/admins/updateDeliveryPrice",

  //EmailTemplates URL
  getEmailTemplates: "api/admins/getEmailTemplates",
  updateEmailTemplate: "api/admins/updateEmailTemplate",

  //Contents URL
  getContent: "api/admins/getContents",
  updateContent: "api/admins/updateContent",

  // Users URL
  getUsers: "api/admins/getUsers",
  getAllUserMultiple: "api/admins/getAllUserMultiple",
  getAllUser: "api/admins/getAllUser",
  addUser: "api/admins/addUser",
  updateUser: "api/admins/updateUser",
  updateUserStatus: "api/admins/updateUserStatus",
  getAllUserCSV: "api/admins/getAllUserCSV",
  getUserWalletHistoryes: "api/admins/getUserWalletHistoryes",
  getUserAllInformation: "api/admins/getUserAllInformation",
  // User Address URL
  getUserAddresses: "api/admins/getUserAddresses",

  //Sellers
  getAllSellerMultiple: "api/admins/getAllSellerMultiple",

  //Dealers
  getAllDealersMultiple: "api/admins/getAllDealersMultiple",

  // Stores URL
  getStores: "api/admins/getStores",
  addStore: "api/admins/addStore",
  updateStore: "api/admins/updateStore",
  updateStoreStatus: "api/admins/updateStoreStatus",
  updateStoreTimings: "api/admins/updateStoreTimings",
  getAllStore: "api/admins/getAllStore",
  getAllStoreMultiple: "api/admins/getAllStoreMultiple",
  getProductInventoryes: "api/admins/getProductInventoryes",
  storeChangePassword: "api/admins/storeChangePassword",
  getBankName: "api/admins/bank",
  verifyISFC: "api/admins/verify-ISFC",
  getAllStoreCSV: "api/admins/getAllStoreCSV",
  storeDetailsUpdate: "api/admins/storeDetailsUpdate",
  getInventStore: "api/admins/getInventStore",
  getOrderStore: "api/admins/getOrderStore",

  // Products URL
  getProducts: "api/admins/getProducts",
  addProduct: "api/admins/addProduct",
  updateProduct: "api/admins/updateProduct",
  updateProductStatus: "api/admins/updateProductStatus",
  getAllProduct: "api/admins/getAllProduct",
  addProductImages: "api/admins/addProductImages",
  deleteProductImages: "api/admins/deleteProductImages",
  uploadProductCSV: "api/admins/uploadProductCSV",
  getAllProductCSV: "api/admins/getAllProductCSV",

  // Posts URL
  getPosts: "api/admins/getPosts",
  addPost: "api/admins/addPost",
  updatePost: "api/admins/updatePost",
  updatePostStatus: "api/admins/updatePostStatus",
  getAllPost: "api/admins/getAllPost",

  // Dealer Shelf URL
  getDealerShelfs: "api/admins/getDealerShelfs",
  addDealerShelf: "api/admins/addDealerShelf",
  updateDealerShelf: "api/admins/updateDealerShelf",
  updateDealerShelfStatus: "api/admins/updateDealerShelfStatus",
  getAllDealerShelf: "api/admins/getAllDealerShelf",

  // Sub admin URL
  getAdmins: "api/admins/getAdmins",
  addAdmin: "api/admins/addAdmin",
  updateAdmin: "api/admins/updateAdmin",
  updateAdminStatus: "api/admins/updateAdminStatus",
  getAllRoles: "api/admins/getAllRoles",
  unlockStatus: "api/admins/unlockStatus",
  // Products inventories URL
  getProductInventories: "api/admins/getProductInventories",
  addProductInventories: "api/admins/addProductInventories",
  updateProductInventories: "api/admins/updateProductInventories",
  updateProductInventoriesStatus: "api/admins/updateProductInventoriesStatus",

  // Discount Code URL
  getDiscountCode: "api/admins/getDiscountCode",
  addDiscountCode: "api/admins/addDiscountCode",
  shareCouponCode: "api/admins/shareCouponCode",
  updateDiscountCode: "api/admins/updateDiscountCode",
  updateDiscountCodeStatus: "api/admins/updateDiscountCodeStatus",

  // Delivery boys URL
  getDeliveryboys: "api/admins/getDeliveryboys",
  addDeliveryboys: "api/admins/addDeliveryboys",
  updateDeliveryboys: "api/admins/updateDeliveryboys",
  updateDeliveryboysStatus: "api/admins/updateDeliveryboysStatus",
  getAllVehicleType: "api/admins/getAllVehicleType",
  getActiveDrivers: "api/admins/getActiveDrivers",
  getOrderDrivers: "api/admins/getOrderDrivers",
  getAllDriverCSV: "api/admins/getAllDriverCSV",
  driverDetailsUpdate: "api/admins/driverDetailsUpdate",
  // Order URL
  currentOrders: "api/admins/currentOrders",
  getOrdersHistory: "api/admins/getOrdersHistory",
  updateOrderStatus: "api/admins/updateOrderStatus",
  updateCashStatus: "api/admins/updateCashStatus",
  getDriverUserLatLng: "api/admins/getDriverUserLatLng",
  getDriverLatLng: "api/admins/getDriverLatLng",
  getOrderItems: "api/admins/getOrderItems",
  // Refund Url
  getRefundProducts: "api/admins/getRefundProducts",
  refundProductStatusUpdate: "api/admins/refundProductStatusUpdate",
  getRefundReasons: "api/admins/getRefundReasons",
  updateRefundReason: "api/admins/updateRefundReason",

  getCancelReasons: "api/admins/getCancelReasons",
  updateCancelReasons: "api/admins/updateCancelReasons",

  // Product Request Url
  getProductsRequest: "api/admins/getProductsRequest",
  updateProductsRequestStatus: "api/admins/updateProductsRequestStatus",

  // Withdrawal Request Url
  getWithdrawalRequest: "api/admins/getWithdrawalRequest",
  updatWithdrawalRequestStatus: "api/admins/updatWithdrawalRequestStatus",

  // Notification Request Url
  getNotifications: "api/admins/getNotifications",
  addNotification: "api/admins/addNotification",
  deleteAdminNotification: "api/admins/deleteAdminNotification",
  resendAdminNotification: "api/admins/resendAdminNotification",
  VerifyEmailStore: "api/admins/verify-email-store",
  VerifyEmailDriver: "api/admins/verify-email-driver",
  VerifyEmail: "api/admins/verify-email",

  // Reports Request URL
  completeOrder: "api/admins/completeOrder",

  updateColorStatus: "api/admins/updateColorStatus",
  addColor: "api/admins/addColor",
  editColor: "api/admins/editColor",
  getCOlor: "api/admins/getColor",
  getAllColorList: "api/admins/get-all-color-list",
  getFeatureList: "api/admins/get-feature-list1",
  updateFeatureStatus: "api/admins/update-feature-status",

  //Country List
  countryList: "api/users/country_list",

  ImportProduct: "api/admins/import-product",
  ImportMainService: "api/admins/import-main-service",
  ImportService: "api/admins/import-service",
  ImportCar: "api/admins/import-car",
  ImportCategory: "api/admins/import-category",
  ImportSubCategory: "api/admins/import-sub-category",
  ImportBrand: "api/admins/import-brand",
  ImportModel: "api/admins/import-model",
  ImportVariant: "api/admins/import-variant",

};
export default pathObj;
